<template>
  <div>
    <section class="py-12 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-lg mb-12">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            PDF 转 Word 文档在线转换工具
          </h1>
          <p class="text-lg md:text-xl text-gray-700 mb-8">
            快速、方便、高质量地将您的PDF文件转换为可编辑的Word文档 (.docx)，完全免费！
          </p>
          
          <div class="mt-8 mb-4">
            <FileUploader />
          </div>
          
          <p class="text-sm text-gray-600 mt-4" v-if="!authStore.isAuthenticated">
            <!-- 未登录用户每天可免费转换 {{ conversionStore.settings.guest_limit }} 个文件。 -->
             免费注册账号。
            <router-link to="/register" class="text-blue-600 hover:underline">注册账号</router-link>
            解锁无限转换！
          </p>
        </div>
      </div>
    </section>
    
    <section class="py-8">
      <div class="container mx-auto px-4">
        <h2 class="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
          为什么选择我们的转换工具？
        </h2>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <FeatureCard 
            title="高质量转换" 
            description="我们的转换引擎可以精确保留文档格式、字体和图像，确保转换后的文档与原始PDF保持一致。"
          >
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </template>
          </FeatureCard>
          
          <FeatureCard 
            title="简单易用" 
            description="只需点击几下，即可完成转换过程。无需复杂的操作或专业知识，任何人都可以轻松使用。"
          >
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </template>
          </FeatureCard>
          
          <FeatureCard 
            title="安全可靠" 
            description="我们重视您的隐私和数据安全。文件转换完成下载后请进入（转换历史）列表删除，服务器会定时清除未删除的数据，我们不会保存您的文件内容。"
          >
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </template>
          </FeatureCard>
        </div>
      </div>
    </section>
    
    <section class="py-12 bg-gray-100 rounded-lg mt-12">
      <div class="container mx-auto px-4 text-center">
        <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
          准备好开始了吗？
        </h2>
        <p class="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
          立即上传您的PDF文件，体验快速、高质量的转换服务。
        </p>
        <router-link 
          to="/register" 
          class="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          v-if="!authStore.isAuthenticated"
        >
          注册免费账号
        </router-link>
      </div>
    </section>
  </div>
</template>

<script setup>
import FileUploader from '../components/FileUploader.vue';
import FeatureCard from '../components/FeatureCard.vue';
import { useAuthStore } from '../stores/auth';
import { useConversionStore } from '../stores/conversion';

const authStore = useAuthStore();
const conversionStore = useConversionStore();
//console.log(111,conversionStore);
</script>